import { cn } from '@/shared/utils/cn';
import React from 'react';

export interface ListSeparatorProps {
  className?: string;
}

export const ListSeparator: React.FC<ListSeparatorProps> = ({ className }) => {
  return (
    <li className={cn('ui-list-none ui-px-4', className)}>
      <div
        className="ui-m-0 ui-box-border ui-h-0 ui-w-full ui-border-0 ui-border-t ui-border-solid ui-border-default"
        role="presentation"
      />
    </li>
  );
};
